import { useState } from "react";

import {
  makeGetApiCall,
  makePostApiCall,
  makePutApiCall,
} from "../../../shared/makeApiCall";
import NewWarehouseForm from "../../../components/forms/setup/warehouses/NewWarehouseForm";
import { createSnackbarHelpers } from "../../../shared/snackbar";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { updateObjectInArray } from "../../../shared/utility";

export function WarehousesViewModel(logout, addSnackbar) {
  const [loading, setLoading] = useState(false);
  const [warehouses, setWarehouses] = useState({
    data: [],
  });
  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const { showSuccess } = createSnackbarHelpers(addSnackbar);

  const getWarehouses = async function (search, page) {
    setLoading(true);

    let callResult = await makePostApiCall(
      `warehouses?page=${page}&search=${search}`
    );
    setLoading(false);
    if (callResult.success) {
      setWarehouses(callResult.data);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createWarehouse = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("warehouses/create", payload);

    if (callResult.success) {
      showSuccess("Warehouse added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getWarehouses("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateWarehouse = async function (values, index) {
    let callResult = await makePutApiCall(`warehouses/${values.id}`, values);

    if (callResult.success) {
      showSuccess("Warehouse updated");
      setSlideOver({
        childComponent: null,
        open: false,
      });

      const currentItems = [...warehouses.data];
      var payload = {
        index: index,
        item: callResult.data.item,
      };
      const newItems = updateObjectInArray(currentItems, payload);
      setWarehouses({ ...warehouses, data: newItems });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const makeAddLocationRequest = async function (payload) {
    let callResult = await makePostApiCall(
      "warehouses/locations/create",
      payload
    );

    if (callResult.success) {
      showSuccess("Warehouse added");
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getWarehouses("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddWarehouseSlideOver = (isEdit, warehouse, index) => {
    setSlideOver({
      childComponent: (
        <NewWarehouseForm
          warehouse={warehouse}
          makeAddLocationRequest={makeAddLocationRequest}
          isEdit={isEdit}
          setOpen={setSlideOver}
          actionCall={(payload) =>
            isEdit ? updateWarehouse(payload, index) : createWarehouse(payload)
          }
          title={isEdit ? `Update ${warehouse.name}` : "Add new warehouse"}
        />
      ),
      open: true,
    });
  };

  const deleteWarehouse = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteWarehouse/${id}`);
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });

      const newItems = warehouses.data.filter((item) => item.id !== id);
      setWarehouses({ ...warehouses, data: newItems });

      showSuccess(callResult.data.message);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const askDeleteWarehouse = function (warehouse, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteWarehouse(warehouse.id, index)}
          message={`Are you sure you want to delete  ${warehouse.name}?`}
          setOpen={setEmptyModelOpen}
          hideReason={true}
        />
      ),
      open: true,
    });
  };

  return {
    openAddWarehouseSlideOver,
    getWarehouses,
    loading,
    warehouses,
    setSlideOver,
    slideOver,
    setEmptyModelOpen,
    emptyModal,
    askDeleteWarehouse,
  };
}
